// Module
var code = `<div class="container">
</div>
`;
// Exports
export default code;